import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,8.2493615 17.4376862,6.6300585 16.4838237,5.3128559 L9.7995845,11.9966883 L14.609621,11.9963954 C15.1525978,11.9963954 15.5927674,12.4365651 15.5927674,12.9795419 C15.5927674,13.5225186 15.1525978,13.9626883 14.609621,13.9626883 L7.3490837,13.9625147 C7.3046583,13.9625147 7.2609212,13.9595682 7.218057,13.9538597 C7.1569501,13.9457898 7.098078,13.9321372 7.0414785,13.9134831 C7.0235605,13.9075452 7.0055008,13.901009 6.9876959,13.8939679 C6.8614983,13.8439703 6.7483892,13.7688474 6.6542732,13.6747314 L6.5819235,13.5942763 C6.4467848,13.425894 6.3659373,13.2120726 6.3659373,12.9793683 L6.3659373,5.71921 C6.3659373,5.1762333 6.8061069,4.7360636 7.3490837,4.7360636 C7.8920605,4.7360636 8.3322301,5.1762333 8.3322301,5.71921 L8.3325845,10.6596883 L15.1298813,3.8609921 C13.7411147,2.6992664 11.9522186,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z"
      transform="translate(2 2)"
      fill={fill}
    />
  </g>
);

export default Icon;
